import type { FlowStep } from "@/common/flow/flow-step.types";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import type { ReplacementDraft } from "./replacement.types";

const DELIVERY_ERRORS = "replacement.chooseDelivery.errors";

const isChooseDeviceComplete = (draft: ReplacementDraft): boolean =>
  Boolean(draft.deviceId && draft.keyboardLayout);

const firstDeliveryGap = (draft: ReplacementDraft): string | undefined => {
  if (!draft.deliveryMethod) return getString(`${DELIVERY_ERRORS}.methodRequired`);
  if (draft.deliveryMethod === "ship") {
    if (!draft.shippingAddress) return getString(`${DELIVERY_ERRORS}.shippingAddressRequired`);
    return draft.isEditing ? getString(`${DELIVERY_ERRORS}.unsavedAddress`) : undefined;
  }
  return draft.pickup ? undefined : getString(`${DELIVERY_ERRORS}.buildingRequired`);
};

export const chooseDeviceStep: FlowStep<ReplacementDraft> = {
  id: "choose-device",
  label: "Choose device",
  isReachable: () => true,
  validate: (draft) =>
    isChooseDeviceComplete(draft)
      ? undefined
      : "Choose a device and a keyboard layout to continue.",
};

export const chooseDeliveryStep: FlowStep<ReplacementDraft> = {
  id: "choose-delivery",
  label: "Choose delivery",
  isReachable: isChooseDeviceComplete,
  validate: firstDeliveryGap,
};

export const reviewStep: FlowStep<ReplacementDraft> = {
  id: "review",
  label: "Review details",
  isReachable: (draft) => isChooseDeviceComplete(draft) && !firstDeliveryGap(draft),
  validate: () => undefined,
};

export const replacementSteps: FlowStep<ReplacementDraft>[] = [
  chooseDeviceStep,
  chooseDeliveryStep,
  reviewStep,
];
